module.exports = __webpack_public_path__ + "static/img/animales_05.b5707c37.jpg";